import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import Section from "@/components/editorial/Section";
import SectionHeader from "@/components/editorial/SectionHeader";
import StoryCardApi from "@/components/editorial/StoryCardApi";
import { STORIES as FALLBACK } from "@/data/content";
import { fetchStories } from "@/lib/stories";

/**
 * Fetches latest 4 published stories from API with static fallback.
 * Static fallback uses the same 4 seed stories so homepage never breaks.
 */
export default function FeaturedStories() {
  const [stories, setStories] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchStories({ limit: 4 })
      .then((data) => {
        if (!alive) return;
        setStories(data.items && data.items.length > 0 ? data.items : null);
      })
      .catch(() => {
        if (!alive) return;
        setStories(null);
      });
    return () => {
      alive = false;
    };
  }, []);

  // Map static fallback shape to API shape
  const items =
    stories ||
    FALLBACK.map((f) => ({
      id: f.slug,
      slug: f.slug,
      name: f.name,
      city: f.city,
      industry: f.industry,
      short_quote: f.quote,
      portrait_url: f.image,
      season: "Temporada 1",
    }));

  return (
    <Section tone="cream" padding="xl" testid="featured-stories">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
        <SectionHeader
          eyebrow="Historias destacadas"
          title={
            <>
              Mujeres que están<br />
              <span className="italic">moviendo México.</span>
            </>
          }
          description="Cuatro retratos documentales. Cuatro ciudades. Un mismo pulso: mujeres cambiando su industria desde adentro."
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
        {items.slice(0, 4).map((s, i) => (
          <StoryCardApi key={s.id || s.slug} story={s} index={i} />
        ))}
      </div>

      <div className="mt-14 md:mt-16 flex justify-end">
        <a
          href="/stories"
          data-testid="see-all-stories"
          className="group inline-flex items-center gap-2 text-sm text-charcoal hover:text-terracotta transition-colors"
        >
          Ver todas las historias
          <ArrowRight className="h-4 w-4 transition-transform duration-[400ms] group-hover:translate-x-1" />
        </a>
      </div>
    </Section>
  );
}
